const btnSearch = document.querySelector( '.btn-search' );
const boxSearch = document.querySelector( '.box-search' );
const menuTrigger = document.querySelector( '.menu-trigger' );
const navbarAside = document.querySelector( '.navbar-aside' );
const navbarBackdrop = document.querySelector( '.navbar-backdrop' );

function closeAll() {
	boxSearch?.classList.remove( 'active' );
	navbarAside?.classList.remove( 'active' );
	menuTrigger?.classList.remove( 'active' );
}

function updateBackdrop() {
	const isActive =
		boxSearch?.classList.contains( 'active' ) ||
		navbarAside?.classList.contains( 'active' );

	navbarBackdrop?.classList.toggle( 'active', isActive );
	document.body.style.overflow = isActive ? 'hidden' : '';
}

btnSearch?.addEventListener( 'click', ( e ) => {
	e.preventDefault();

	const willOpen = ! boxSearch.classList.contains( 'active' );
	closeAll();

	if ( willOpen ) {
		boxSearch.classList.add( 'active' );
	}

	updateBackdrop();
} );

menuTrigger?.addEventListener( 'click', ( e ) => {
	e.preventDefault();

	const willOpen = ! navbarAside.classList.contains( 'active' );
	closeAll();

	if ( willOpen ) {
		navbarAside.classList.add( 'active' );
		menuTrigger.classList.add( 'active' );
	}

	updateBackdrop();
} );

navbarBackdrop?.addEventListener( 'click', () => {
	closeAll();
	updateBackdrop();
} );
